@import '../../themes/capsule.globals';

:host {
  --container-border-radius: var(--cpsl-border-radius-table-container);
  --container-border-color: var(--cpsl-color-background-16);
  --container-background-color: var(--cpsl-color-background-0);
  --container-border-width: 1px;

  --container-header-padding-top: 24px;
  --container-header-padding-bottom: 24px;
  --container-header-padding-start: 24px;
  --container-header-padding-end: 24px;
  --container-header-border-width: 1px;
  --container-header-border-color: var(--cpsl-color-background-16);

  --container-footer-padding-top: 16px;
  --container-footer-padding-bottom: 16px;
  --container-footer-padding-start: 24px;
  --container-footer-padding-end: 24px;
  --container-footer-border-width: 1px;
  --container-footer-border-color: var(--cpsl-color-background-8);

  --table-header-padding-top: 16px;
  --table-header-padding-bottom: 16px;
  --table-header-padding-start: 24px;
  --table-header-padding-end: 24px;
  --table-header-background-color: var(--cpsl-color-background-4);
  --table-header-border-color: var(--cpsl-color-background-16);
  --table-header-border-width: 1px;

  --table-content-padding-top: 16px;
  --table-content-padding-bottom: 16px;
  --table-content-padding-start: 24px;
  --table-content-padding-end: 24px;
  --table-content-border-color: var(--cpsl-color-background-8);
  --table-content-border-width: 1px;

  display: block;
}

:host {
  cpsl-card {
    height: 100%;
    --card-padding-top: 0px;
    --card-padding-bottom: 0px;
    --card-padding-start: 0px;
    --card-padding-end: 0px;
    --card-border-width: var(--container-border-width);
    --card-border-color: var(--container-border-color);
    --card-border-radius: var(--container-border-radius);
    --card-background-color: var(--container-background-color);

    &::part(card-container) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
}

.content {
  flex: 1;
  overflow: auto;
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;

  &.horizontal-scroll:not(.vertical-scroll) {
    box-shadow: -24px 0px 24px -24px rgba(0, 0, 0, 0.1) inset;
  }

  &.vertical-scroll:not(.horizontal-scroll) {
    box-shadow: 0px -24px 24px -24px rgba(0, 0, 0, 0.1) inset;
  }

  &.horizontal-scroll.vertical-scroll {
    box-shadow: -24px -24px 24px -24px rgba(0, 0, 0, 0.1) inset;
  }
}

.table-wrapper {
  overflow: auto;
  height: 100%;
}

.container-header {
  display: none;

  @include padding(var(--container-header-padding-top), var(--container-header-padding-end), var(--container-header-padding-bottom), var(--container-header-padding-start));
  border-bottom: var(--container-header-border-width) solid var(--container-header-border-color);
}

.container-footer {
  display: none;

  @include padding(var(--container-footer-padding-top), var(--container-footer-padding-end), var(--container-footer-padding-bottom), var(--container-footer-padding-start));
  border-top: var(--container-footer-border-width) solid var(--container-footer-border-color);
}

.shown {
  display: block;
}
